module.exports = __webpack_public_path__ + "static/img/13.74250f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/333/22/13.png
// module id = uAv7
// module chunks = 0